<script setup>
/* eslint-disable */
import { onMounted, watch, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useRegionsStore } from '@/stores/regions';
import { useGeneralStore } from '@/stores/general';
import { usePreSportsStore } from '@/stores/pre_sports';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
import RegionCoupon from './RegionCoupon.vue';

const router = useRouter();
const regionsStore = useRegionsStore();
const preSportsStore = usePreSportsStore();
const generalStore = useGeneralStore();


onMounted(() => {
	let selected_pre_sport = _.find(preSportsStore.preSports, {'id': Number(router.currentRoute.value.params.sport_id) });
	if (selected_pre_sport) document.title = generalStore.getGeneral.site_name + ' - ' + selected_pre_sport.name + ' ' + t('general.coupons');
})

watch(() => preSportsStore.preSports, (newSports, oldSports) => {
	if (oldSports.length == 0 && newSports.length > 0) {
		let selected_pre_sport = _.find(preSportsStore.preSports, {'id': Number(router.currentRoute.value.params.sport_id) });
		if (!selected_pre_sport) return;
		document.title = generalStore.getGeneral.site_name + ' - ' + selected_pre_sport.name + ' ' + t('general.coupons');
	}
})

</script>
<template>

	<div class="accordion-outer-coupon">
		<div v-if="regionsStore.regionsCompetitionsCoupons && regionsStore.regionsCompetitionsCoupons.length > 0" class="accordion-coupon">
			<!-- iteration on country data -->
			<RegionCoupon v-for="region in regionsStore.regionsCompetitionsCoupons" :key="region.id" :region="region"/>
		</div>

		<div v-else-if="regionsStore.regionsCompetitionsCoupons && regionsStore.regionsCompetitionsCoupons.length === 0" class="empty-state">
			<div class="empty-state-icon">
				<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
					<circle cx="12" cy="12" r="10"/>
					<line x1="12" y1="8" x2="12" y2="12"/>
					<line x1="12" y1="16" x2="12.01" y2="16"/>
				</svg>
			</div>
			<h3 class="empty-state-title">{{ $t('general.no_fixtures_available', 'No regions or competitions available') }}</h3>
			<p class="empty-state-subtitle">{{ $t('general.no_fixtures_message', 'There are no upcoming events for the selected time period. Try adjusting your filters or check back later.') }}</p>
		</div>
	</div>
</template>
<style scoped>
@media screen and (min-width: 320px) and (max-width: 991px) {
	.accordion-coupon{
		max-height: unset !important;
	}
}

.accordion-coupon {
    overflow-y: auto !important;
    overflow-x: hidden !important;
    scrollbar-width: thin !important;
    scrollbar-color: var(--primary) transparent !important;
}

.empty-state {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 60px 24px;
	text-align: center;
	opacity: 0;
	animation: fadeIn 0.4s ease forwards;
}

@keyframes fadeIn {
	to { opacity: 1; }
}

.empty-state-icon {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 80px;
	height: 80px;
	border-radius: 50%;
	background: rgba(var(--primary-rgb, 99, 162, 70), 0.08);
	color: var(--primary, #63A246);
	margin-bottom: 20px;
}

.empty-state-title {
	font-size: 1.15rem;
	font-weight: 600;
	color: var(--white, #fff);
	margin: 0 0 8px 0;
}

.empty-state-subtitle {
	font-size: 0.875rem;
	color: var(--light-gray, #8a8f98);
	margin: 0;
	max-width: 360px;
	line-height: 1.5;
}

</style>